import {
	type DefaultMantineColor,
	SimpleGrid,
	type SimpleGridProps,
	type StyleProp,
} from '@mantine/core';

import type { IconElement } from '@apple/assets/icons';
import type { CustomButtonIconProps } from '@apple/ui/layouts/components/button-with-icon';
import { CustomIconButton } from '@apple/ui/layouts/components/button-with-icon';
import { useBreakpoints } from '@apple/ui/layouts/hooks/useBreakpoints';
import { useLeftSidebarCollapsed } from '@apple/ui/shell/contexts/left-sidebar';

export type DashboardCard = Omit<CustomButtonIconProps, 'text' | 'icon' | 'backgroundColor'> & {
	title: string;
	icon: IconElement;
	color: StyleProp<DefaultMantineColor>;
	hidden?: boolean;
};

type Props = SimpleGridProps & {
	cards: DashboardCard[];
};

export function Dashboard({ cards, ...gridProps }: Props) {
	const leftSidebarCollapsed = useLeftSidebarCollapsed();
	const { smOrLarger, xsOrSmaller } = useBreakpoints();
	const gridCols = xsOrSmaller ? 1 : smOrLarger && leftSidebarCollapsed.isCollapsed ? 3 : 2;

	return (
		<SimpleGrid cols={{ base: gridCols, lg: 2 }} {...gridProps}>
			{cards
				.filter(x => !x.hidden)
				.map(({ icon: IconElement, title, color, ...toOptions }, index) => (
					<CustomIconButton
						{...toOptions}
						icon={<IconElement size='2rem' c='var(--mantine-primary-color-contrast)' />}
						text={title}
						key={index}
						backgroundColor={color}
					/>
				))}
		</SimpleGrid>
	);
}
